import { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
import cn from '../../utils/cn';

export const Button = forwardRef(function Button(
  { variant = 'secondary', size, block, loading, icon: Icon, iconRight: IconRight, children, className, disabled, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      className={cn('btn', `btn--${variant}`, size && `btn--${size}`, block && 'btn--block', className)}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <Loader2 size={15} className="spin" /> : Icon ? <Icon size={size === 'sm' ? 14 : 16} /> : null}
      {children}
      {IconRight && !loading ? <IconRight size={size === 'sm' ? 14 : 16} /> : null}
    </button>
  );
});

export const IconButton = forwardRef(function IconButton({ icon: Icon, label, size = 17, active, className, ...rest }, ref) {
  return (
    <button
      ref={ref}
      type="button"
      className={cn('btn--icon', active && 'is-active', className)}
      aria-label={label}
      title={label}
      {...rest}
    >
      <Icon size={size} />
    </button>
  );
});

export function ButtonGroup({ options, value, onChange }) {
  return (
    <div className="btn-group" role="group">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={cn(value === opt.value && 'is-active')}
          aria-label={opt.label}
          aria-pressed={value === opt.value}
          title={opt.label}
          onClick={() => onChange(opt.value)}
        >
          <opt.icon size={16} />
        </button>
      ))}
    </div>
  );
}

export default Button;
